import { redirect } from '@tanstack/react-router';
import { message } from 'antd';
import type {
    TipoPermissao,
    UsuarioPermissao,
} from '@/features/usuario/types/UsuarioTipoPermissao';
import { useLoginStore } from '@/features/login/store';
import { getUserPermissions } from '@/features/login/util/permission';

function redirectToMain() {
    message.error('Você não tem permissão para acessar essa página.');
    throw redirect({ to: '/' });
}

export function validateRoute({
    fintech,
    condition,
    validatePermission,
}: {
    fintech: boolean;
    condition?: boolean;
    validatePermission?: (permissions: Record<UsuarioPermissao, TipoPermissao>) => boolean;
}) {
    if (condition === false) {
        redirectToMain();
    }

    const { isFintech } = useLoginStore.getState();

    if (isFintech && !fintech) {
        redirectToMain();
    }

    if (!validatePermission) {
        return;
    }

    const userPermissions = getUserPermissions();

    if (!validatePermission(userPermissions)) {
        redirectToMain();
    }
}
